import { addNotification } from 'reapop';
import { reset } from 'redux-form';

import { custom } from 'utils/Api';

import * as types from 'constants/ActionTypes';
import { get, set } from 'lodash';

export function newPasswordRequest() {
  return {
    type: types.NEW_PASSWORD_REQUEST,
  };
}

export function newPasswordSuccess() {
  return {
    type: types.NEW_PASSWORD_SUCCESS,
  };
}

export function newPasswordFailure(error) {
  return {
    type: types.NEW_PASSWORD_FAILURE,
    error,
  };
}

export function newPassword({ OldPassword, NewPassword, ConfirmPassword }) {
  return (dispatch, getState) => {
    dispatch(newPasswordRequest());
    const { loginReducer: { user: { token } } } = getState();

    const config = {
      url: '/api/Account/ChangePassword',
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      data: {
        OldPassword,
        NewPassword,
        ConfirmPassword,
      },
    };

    custom(config)
      .then(() => {
        dispatch(newPasswordSuccess());
        dispatch(reset('NewPassword'));
        dispatch(addNotification({
          title: 'Vistað',
          message: 'Nýtt lykilorð hefur verið vistað',
          status: 'success',
          dismissable: true,
          dismissAfter: 4000,
        }));
      })
      .catch((error) => {
        console.log('error', error);
        const innerMessage = get(error, ['ModelState', 'model.NewPassword', 0]);
        if (innerMessage) {
          set(error, 'Message', innerMessage);
        }
        dispatch(newPasswordFailure(error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/Settings.js